<template>
  <b-card title="Email Address" border-variant="Primary" class="text-center mt-3">
    <b-form @submit.prevent="onSubmit" novalidate :validated="wasValidated">
      <b-form-group :label="$t('lang.label_email')" label-for="input-email" label-cols-sm="5">
        <label class="text-color">{{ this.userEmail }}</label>
      </b-form-group>
      <b-form-group v-if="isEdit || requestSubmitted" :label="$t('lang.label_email_new')" label-for="input-email-new" label-cols-sm="5">
        <b-form-input v-if="isEdit" v-model="cachedNewEmail" id="input-email-new" type="email"></b-form-input>
        <label class="text-color" v-if="requestSubmitted && !isEdit">{{this.new_email}}</label>
        <p v-if="requestSubmitted && !isEdit">{{ $t("lang.label_mail_not_verified") }}</p>
      </b-form-group>
      <p v-if="requestSubmitted">
        <b>{{ $t("lang.label_email_not_received") }}</b>
        <br />
        <b-button variant="link" @click="resendVerificationEmail">{{ $t("lang.label_resend_email") }}</b-button>
      </p>
      <p v-if="requestSubmitted">{{ $t("lang.message_user_email_change_requested") }}.</p>
      <b-row>
        <b-col sm class="text-center mt-4">
          <b-button type="submit" variant="primary">{{ getButtonText }}</b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>
<script>
import API from "@/api";
export default {
  name: "UserEmailUpdate",
  props: { email: String },
  data() {
    return {
      wasValidated: false,
      isEdit: false,
      userEmail: this.email,
      cachedNewEmail: this.new_email,
    };
  },
  computed: {
    getButtonText() {
      return this.isEdit ? this.$t("lang.label_save") : this.$t("lang.label_edit");
    },
    requestSubmitted() {
      return this.$store.getters["auth/emailChangeRequested"];
    },
    new_email()
    {
      return this.$store.getters["auth/new_email"];
    }
  },
  methods: {
    onSubmit() {
      this.isEdit = !this.isEdit;
      if (!this.isEdit) this.updateEmail();
    },
    resendVerificationEmail() {
      API.resendUpdateEmailVerification(this.new_email)
        .then(() => {
          this.$store.dispatch("alert/showSuccessAlert", this.$t("lang.message_verification_email_sent_success"));
        })
        .catch(() => {
          this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_verification_email_sent_error"));
        });
    },
    updateEmail() {
      this.$store.dispatch("startLoading");
      API.updateUserEmail(this.cachedNewEmail)
        .then(() => {
          this.$store.dispatch("auth/setEmailChangeRequested", true);
          this.$store.dispatch("auth/setNewEmail", this.cachedNewEmail.toLowerCase());
          this.$store.dispatch("stopLoading");
          this.$store.dispatch("alert/showSuccessAlert", this.$t("lang.message_user_email_update_success"));
        })
        .catch(() => {
          this.$store.dispatch("auth/setNewEmail", "");
          this.$store.dispatch("auth/setEmailChangeRequested", false);
          this.$store.dispatch("stopLoading");
          this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_user_email_update_error"));
        });
    }
  }
};
</script>
